import styled from 'styled-components';
import theme from '@styles/theme';

type FontType = {
    $fontSize?: number;
    $fontColor?: string;
    $margin?: string;
};

type FlexBoxType = {
    $width?: string;
    $height?: string;
    $flex?: number;
    $flexDirection?: string;
    $alignItems?: string;
    $justifyContent?: string;
    $flexWrap?: string;
    $gap?: number;
    $margin?: string;
    $padding?: string;
    $border?: string;
};

export const Wrapper = styled.main<{ $minHeight?: string }>`
    display: flex;
    height: 100%;
    min-height: ${({ $minHeight }) =>
        $minHeight ? $minHeight : 'calc(100vh - 80px)'};
`;

export const BoldFont = styled.div<FontType>`
    font-family: PretendardBold, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const SemiBoldFont = styled.div<FontType>`
    font-family: PretendardSemiBold, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const MediumFont = styled.div<FontType>`
    font-family: PretendardMedium, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const RegularFont = styled.div<FontType>`
    font-family: PretendardRegular, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const FlexBox = styled.div<FlexBoxType>`
    display: flex;
    flex: ${({ $flex }) => ($flex ? $flex : 1)};
    flex-direction: ${({ $flexDirection }) =>
        $flexDirection ? $flexDirection : 'row'};
    align-items: ${({ $alignItems }) => ($alignItems ? $alignItems : 'center')};
    justify-content: ${({ $justifyContent }) =>
        $justifyContent ? $justifyContent : 'flex-start'};
    flex-wrap: ${({ $flexWrap }) => ($flexWrap ? $flexWrap : 'unset')};
    gap: ${({ $gap }) => ($gap ? $gap : 0)}px;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    padding: ${({ $padding }) => ($padding ? $padding : 0)};
    width: ${({ $width }) => ($width ? $width : '100%')};
    height: ${({ $height }) => ($height ? $height : '100%')};
`;

export const Contents = styled.div<{ $margin?: string }>`
    flex: 1;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;
export const FilterBox = styled.div<{ $margin?: string }>`
    display: flex;
    gap: 20px;
    margin: ${({ $margin }) => ($margin ? $margin : '0 0 10px')};
    line-height: 1.5;
    select {
        font-family: PretendardRegular, sans-serif;
    }
    input {
        font-size: 14px;
        font-family: PretendardRegular, sans-serif;
    }
`;
export const Line = styled.div<{ $margin?: string }>`
    height: 1px;
    margin: ${({ $margin }) => ($margin ? $margin : '30px 0')};
    background-color: ${theme.colors.ultraLightGrayBorder};
`;
export const Description = styled(RegularFont)<{
    $margin?: string;
    $width?: string;
    $fontColor?: string;
    $fontSize?: number;
}>`
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 12)}px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};
    margin: ${({ $margin }) => ($margin ? $margin : '8px 0 0')};
    max-width: ${({ $width }) => ($width ? $width : 'auto')};
    white-space: normal;
    word-break: keep-all;
`;

export const Section = styled.section<{
    $padding?: string;
    $maxWidth?: number;
}>`
    display: flex;
    padding: ${({ $padding }) => ($padding ? $padding : 0)};
    width: 100%;
    max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'auto')};
    border-top: ${theme.colors.ultraLightGrayBorder} 1px solid;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: end;
    gap: 8px;
    margin-top: 32px;
`;

export const Image = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
